<template>
  <div>
    <div class="actionForm">
        <h2>Share Configuration <span class="configName"> — {{ config.name }}</span></h2>

        <form class="form" autocomplete="off" @submit.prevent>
          <ul>
            <li class="privacy">
              <p class="formInfo">You can make your configuration public or private. If you set your configuration to public, you will be provided a shareable link which you can use to share your configuration in read-only mode.</p>
              <label for="privateConfig">
                <input type="radio" v-model="visibility" id="privateConfig" value="private">
                Private Configuration
              </label><br/>
              <label for="publicConfig">
                <input type="radio" v-model="visibility" id="publicConfig" value="public">
                Public Configuration
              </label>
            </li>
            <li v-if="isShared" class="shareLink">
              <hr/>
              <div class="get">
                <p>Public Shareable Link <span class="copied">Copied to clipboard</span></p>
                <input :value="siteBaseUrl + '/manage/config/public/' + config.configId" id="configLink"/>
                <a class="copyLink" @click="copyLink">
                  <svg xmlns="http://www.w3.org/2000/svg" width="10.996" height="11" viewBox="0 0 10.996 11"><path d="M5.841,11.771H5.824c-.088.007-.175.01-.263.01a3.517,3.517,0,0,1-1.3-.248.226.226,0,0,0-.081-.015.22.22,0,0,0-.156.065l-.584.584a1.255,1.255,0,0,1-1.774-1.774L3.558,8.5a1.252,1.252,0,0,1,.611-.336,1.267,1.267,0,0,1,1.437.731.219.219,0,0,0,.161.128.219.219,0,0,0,.2-.061l.988-.987A.22.22,0,0,0,6.979,7.7a3.043,3.043,0,0,0-4.69-.466L.4,9.124a3.049,3.049,0,0,0,4.312,4.312L6,12.147a.22.22,0,0,0-.156-.376Z" transform="translate(0.496 -3.328)" fill="#00adb5"/><path d="M14.043.393a3.049,3.049,0,0,0-4.311,0L8.443,1.681a.22.22,0,0,0,.155.376h.017c.088-.007.176-.01.265-.01a3.517,3.517,0,0,1,1.3.248.222.222,0,0,0,.237-.049L11,1.662a1.255,1.255,0,1,1,1.774,1.774L10.88,5.331a1.258,1.258,0,0,1-1.774,0,1.359,1.359,0,0,1-.275-.4.219.219,0,0,0-.161-.128.21.21,0,0,0-.04,0,.221.221,0,0,0-.156.065l-.988.987a.22.22,0,0,0-.028.277,2.893,2.893,0,0,0,.378.467,3.045,3.045,0,0,0,4.312,0L14.042,4.7A3.053,3.053,0,0,0,14.043.393Z" transform="translate(-3.938 0.5)" fill="#00adb5"/></svg>
                  COPY LINK
                </a>
                <a class="openLink" :href="siteBaseUrl + '/manage/config/public/' + config.configId" target="_blank">
                  <svg xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 25 25"><path fill="#00ADB5" d="M12.5,0C5.6,0,0,5.6,0,12.5S5.6,25,12.5,25S25,19.4,25,12.5S19.4,0,12.5,0z M18,17.1C18,17.1,18,17.1,18,17.1c0,0.8-0.6,1.4-1.4,1.4H7.9c0,0,0,0-0.1,0c-0.8,0-1.4-0.6-1.3-1.4V9.5c0-0.8,0.6-1.4,1.4-1.5h4.6c0,0,0,0,0,0c0.4,0,0.8,0.4,0.8,0.8c0,0,0,0,0,0c0,0.4-0.4,0.8-0.8,0.8H8.7c0,0,0,0,0,0C8.3,9.6,8,9.9,8,10.3v5.9c0,0,0,0,0,0c0,0.4,0.3,0.7,0.7,0.7h7c0,0,0,0,0,0c0.4,0,0.7-0.3,0.7-0.7v-2.7c0,0,0,0,0,0c0-0.4,0.4-0.8,0.8-0.8c0,0,0,0,0,0c0.4,0,0.8,0.4,0.8,0.8V17.1z M19.2,11.6c0,0.3-0.4,0.5-0.6,0.2c-0.2-0.2-0.4-0.4-0.6-0.6c-0.1-0.2-0.3-0.3-0.4-0.5c-0.1-0.1-0.3-0.3-0.5-0.3c-0.2,0-0.3,0.2-0.5,0.4c-0.1,0.1-0.3,0.3-0.4,0.4c-0.4,0.4-0.7,0.7-1.1,1.1c-0.4,0.4-0.8,0.8-1.2,1.2c-0.1,0.1-0.2,0.2-0.3,0.2c-0.1,0-0.2-0.1-0.3-0.1l-0.8-0.8c-0.2-0.2-0.2-0.5,0-0.6c0.6-0.6,1.3-1.3,1.9-1.9c0.4-0.4,0.8-0.8,1.2-1.2c0,0,0.1-0.1,0.1-0.2c0,0,0-0.1,0-0.1c0-0.3-0.3-0.5-0.5-0.7c-0.3-0.3-0.6-0.5-0.9-0.8c-0.2-0.2-0.3-0.4,0-0.6c0.1,0,0.2,0,0.3,0c1.4,0.1,2.9,0.1,4.3,0.1c0.2,0,0.3,0.2,0.3,0.3L19.2,11.6z"/></svg>
                </a>
              </div>
            </li>
            <li>
              <hr/>
              <input type="button" @click="shareConfig($route.params.id)" class="create btn" value="Save Changes" title="Save Changes"/>
              <router-link :to="($route.params.hasOwnProperty('id')) ? '/manage/config/'+$route.params.id : '/manage'" class="discard btnOutline" title="Discard Changes">Discard Changes</router-link>
            </li>
          </ul>
        </form>
    </div>
  </div>
</template>

<script>
  import store from '../store'
	import axios from 'axios'
  import VueAxios from 'vue-axios'
  import router from '../router'
  import { mixin } from '../components/mixins/mixin'

  export default {
    name: 'ShareConfig',

    mixins: [mixin],

    data: function() {
      return {
        visibility: '',
        isShared: false,
      }
    },

    computed: {
      config() {
        var vm = this;
        var config = {};

        store.state.configs.forEach(function( conf ){
          if(conf.configId === vm.$route.params.id) {
            vm.visibility = conf.public ? 'public' : 'private'
            vm.isShared = conf.public
            config = conf;
            return false;
          }
        });    
        
        return config
      }
    },

    methods: {
      shareConfig(id) {

        const vc = this;

        axios
        .patch(process.env.VUE_APP_API_URL+'/configs/'+id, {
            visibility: vc.visibility
          }, 
          {
            headers: {
                'Authorization': 'Bearer '+store.state.authToken
            }
          }
        )
        .then( function(response){
          vc.notify('<p>Configuration updated successfuly.</p>', true)
          vc.isShared = (vc.visibility == 'public')
          vc.fetchConfigs()
        }).catch(function(err) {
          vc.notify('<p>There was an error trying to update your configuration</p>.', false, 'error')
          console.log(err);
        });
        
        
      },

      getDrop() {
        this.file = event.dataTransfer.files[0];
        console.log(event)
      },
      
      uploadFile: function(e) {
        this.file = this.$refs.file.files[0];
      },

      copyLink() {
        var link = document.getElementById('configLink')
        link.select()
        document.execCommand("copy")
        link.blur()
        $('span.copied').fadeIn();

        setTimeout(function(){
          $('span.copied').fadeOut();
        },2000)
      }
    } 
  }  
</script>


<style scoped>

</style>